import { PocComponentFooter } from 'commons/components/components-wrapper/poc-component-footer.component';
import { PocListItem } from 'commons/components/components-wrapper/poc-list-item.component';
import { PocSideMenu } from 'commons/components/components-wrapper/poc-side-menu.component';
import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';
import { APP_SIDE_MENU_WIDTH } from '../app.layout.constants';

export const SideMenuList = styled(PocSideMenu)`
    width: ${APP_SIDE_MENU_WIDTH};
    min-width: ${APP_SIDE_MENU_WIDTH};

    /* v7 defaults the side-menu prefix icons to the muted foreground-intensity-high (#544f4f);
       v6 rendered them with the dark foreground-base (#121212). Restore it so the nav icons
       match v6. Needs !important to beat owc's default icon colour. */
    owc-icon[slot='prefix'] {
        color: ${owcTheme['one-color-foreground-base']} !important;
    }

    /* OWC-OVERRIDE: v7 shows a blue focus outline on the list-item container when its options
       menu opens (mouse/programmatic focus); v6 didn't. Hide it unless it is a genuine
       keyboard focus (:focus-visible), so the item doesn't get a blue border while its menu is
       open. owc-list-item has no focus-ring prop in v7.6.0 and sets the outline at a
       specificity that needs !important. Revisit on the next @one upgrade. */
    owc-list-item .owc-list-item__list-item-container:not(:focus-visible) {
        outline: none !important;
    }
`;

export const DevInfoMenuFooter = styled(PocComponentFooter).attrs({ slot: 'footer' })`
    display: flex;
    justify-content: center;
`;

export const DevInfoLabel = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${APP_SIDE_MENU_WIDTH};
    height: 20px;
    padding: 0 10px;

    .info-label {
        overflow: hidden;
        text-overflow: ellipsis;
        color: var(--one-color-gray-200);
        white-space: nowrap;
    }
`;

export const SideMenuListItem = styled(PocListItem)`
    .menu-button-options {
        opacity: 0;
        transition: opacity 0.5s;

        /* OWC-OVERRIDE: the collapsed side menu has no room for owc's leading indentation
           column. owc-list-item renders it unconditionally in v7.6.0 with no indentation
           prop. Revisit on the next @one upgrade. */
        .owc-list-item__list-item-container__indentation {
            display: none;
        }

        owc-divider {
            display: none;
        }
    }

    owc-list-item:hover .menu-button-options {
        opacity: 1;
    }

    @media (pointer: coarse) {
        &:active .menu-button-options {
            opacity: 1;
        }

        &.selected .menu-button-options {
            opacity: 1;
        }
    }

    /* OWC-OVERRIDE: the selected menu item needs the brand tint plus a 4px leading bar. owc
       paints its selected state on the internal container in v7.6.0 and exposes no
       selected-style prop, so the container has to be targeted directly. Revisit on the next @one upgrade. */
    &[selected]:not([selected='false']) {
        > .owc-list-item__list-item-container {
            background-color: var(--one-color-interaction-active-brand-lower);
            border-radius: 0;
            box-shadow: inset 0.25rem 0 0 0 var(--one-color-interaction-active-brand-base);
        }
    }
`;
